module.exports = __webpack_public_path__ + "img/banner-one-first.21c79a4f.png";